import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-39ecdf60")

_pushScopeId("data-v-39ecdf60")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "ion-padding-horizontal" }, [
  /*#__PURE__*/_createVNode("h1", { class: "title" }, "Пополнение Summus кошелька"),
  /*#__PURE__*/_createVNode("p", null, "Проверьте данные по оплате перед её отправкой")
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { slot: "start" }, "Пополнение Summus кошелька", -1)
const _hoisted_3 = { slot: "end" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { slot: "start" }, "Комиссия", -1)
const _hoisted_5 = { slot: "end" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { slot: "start" }, "К оплате", -1)
const _hoisted_7 = { slot: "end" }
const _hoisted_8 = /*#__PURE__*/_createVNode("h2", { class: "title" }, "Отправитель", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Анонимно ")
const _hoisted_10 = /*#__PURE__*/_createVNode("h2", { class: "title" }, "Сообщение получателю", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("h2", { class: "title" }, "Данные плательщика", -1)
const _hoisted_12 = { class: "title" }
const _hoisted_13 = {
  key: 1,
  class: "spin"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Apple Pay ")
const _hoisted_15 = /*#__PURE__*/_createVNode("img", { src: "/assets/icon/google-pay-mark.svg" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Credit Card ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" PayPal ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" UnionPay ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Summus")
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Pay ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Pay ")
const _hoisted_23 = /*#__PURE__*/_createVNode("img", { src: "/assets/icon/google-pay.svg" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  style: {"margin-left":"10px"},
  src: "/assets/icon/google-pay-white.svg"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_toolbar = _resolveComponent("toolbar")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_text = _resolveComponent("ion-text")
  const _component_ion_list_header = _resolveComponent("ion-list-header")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_radio = _resolveComponent("ion-radio")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")
  const _component_ion_segment = _resolveComponent("ion-segment")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_pay_pal_button = _resolveComponent("pay-pal-button")
  const _component_wallet_button = _resolveComponent("wallet-button")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_footer = _resolveComponent("ion-footer")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_toolbar, {
        title: 'Summus ' + _ctx.$tr(_ctx.trCartForm, 'wallet'),
        backbutton: true
      }, null, 8, ["title"]),
      _createVNode(_component_ion_content, { fullscreen: "" }, {
        default: _withId(() => [
          _hoisted_1,
          (_ctx.wallet.fee)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_ion_list, { class: "ion-padding-horizontal" }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_item, {
                      lines: "full",
                      class: "ion-no-padding"
                    }, {
                      default: _withId(() => [
                        _hoisted_2,
                        _createVNode("p", _hoisted_3, [
                          _createVNode("b", null, "¥" + _toDisplayString(_ctx.wallet.amount), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      lines: "full",
                      class: "ion-no-padding"
                    }, {
                      default: _withId(() => [
                        _hoisted_4,
                        _createVNode("p", _hoisted_5, [
                          _createVNode("b", null, _toDisplayString(_ctx.wallet.fee.text), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      lines: "full",
                      class: "ion-no-padding"
                    }, {
                      default: _withId(() => [
                        _hoisted_6,
                        _createVNode("p", _hoisted_7, [
                          _createVNode("b", null, "¥" + _toDisplayString(parseFloat(_ctx.wallet.amount) + parseFloat(_ctx.wallet.fee.amount)), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.isAnother)
                  ? (_openBlock(), _createBlock(_component_ion_list, {
                      key: 0,
                      class: "ion-padding-horizontal"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_list_header, { class: "ion-no-padding mt-50" }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_text, { color: "shiawasedo" }, {
                              default: _withId(() => [
                                _hoisted_8
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                          default: _withId(() => [
                            (!_ctx.wallet.isNoSignature)
                              ? (_openBlock(), _createBlock(_component_ion_label, {
                                  key: 0,
                                  class: "ion-text-wrap"
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(_ctx.wallet.fullName), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_ion_label, {
                                  key: 1,
                                  class: "ion-text-wrap"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_9
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.wallet.message)
                  ? (_openBlock(), _createBlock(_component_ion_list, {
                      key: 1,
                      class: "ion-padding-horizontal"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_list_header, { class: "ion-no-padding mt-50" }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_text, { color: "shiawasedo" }, {
                              default: _withId(() => [
                                _hoisted_10
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.wallet.message), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_ion_list, { class: "ion-padding-horizontal" }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_list_header, { class: "ion-no-padding mt-50" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_text, { color: "shiawasedo" }, {
                          default: _withId(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withId(() => [
                            _createVNode("b", null, _toDisplayString(_ctx.$tr(_ctx.trCartForm, 'postalCode')) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.wallet.postalCode), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withId(() => [
                            _createVNode("b", null, _toDisplayString(_ctx.$tr(_ctx.trCartForm, 'country')) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.wallet.country.name), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.wallet.state)
                      ? (_openBlock(), _createBlock(_component_ion_item, {
                          key: 0,
                          class: "ion-no-padding"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                              default: _withId(() => [
                                _createVNode("b", null, _toDisplayString(_ctx.$tr(_ctx.trCartForm, 'state')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.wallet.state), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withId(() => [
                            _createVNode("b", null, _toDisplayString(_ctx.$tr(_ctx.trCartForm, 'city')) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.wallet.city), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.wallet.country.isYandex)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                default: _withId(() => [
                                  _createVNode("b", null, _toDisplayString(_ctx.$tr(_ctx.trCartForm, 'street')) + ":", 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.wallet.street), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_ctx.wallet.house)
                            ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withId(() => [
                                      _createVNode("b", null, _toDisplayString(_ctx.$tr(_ctx.trCartForm, 'house')) + ":", 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.wallet.house), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.wallet.housing)
                            ? (_openBlock(), _createBlock(_component_ion_item, { key: 1 }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withId(() => [
                                      _createVNode("b", null, _toDisplayString(_ctx.$tr(_ctx.trCartForm, 'housing')) + ":", 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.wallet.housing), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.wallet.apartment)
                            ? (_openBlock(), _createBlock(_component_ion_item, {
                                key: 2,
                                lines: "full"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withId(() => [
                                      _createVNode("b", null, _toDisplayString(_ctx.$tr(_ctx.trCartForm, 'apartment')) + ":", 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.wallet.apartment), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createBlock(_component_ion_item, {
                          key: 2,
                          lines: "full",
                          class: "ion-no-padding"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                              default: _withId(() => [
                                _createVNode("b", null, _toDisplayString(_ctx.$tr(_ctx.trCartForm, 'address')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.wallet.address1), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }),
                (_ctx.wallet.currencies && ['paypal', 'paygent', 'wallet'].indexOf(_ctx.payType) === -1)
                  ? (_openBlock(), _createBlock(_component_ion_radio_group, {
                      key: 2,
                      class: "ion-no-padding",
                      modelValue: _ctx.wallet.currencyId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.wallet.currencyId = $event))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_list_header, { class: "ion-padding-horizontal mt-50" }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_text, { color: "shiawasedo" }, {
                              default: _withId(() => [
                                _createVNode("h2", _hoisted_12, _toDisplayString(_ctx.$tr(_ctx.trCartForm, 'chooseCurrency')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.wallet.currencies, (currency, key) => {
                          return (_openBlock(), _createBlock(_component_ion_card, {
                            key: key,
                            class: "currency-card"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_item, {
                                lines: "none",
                                class: {'currency-checked': _ctx.wallet.currencyId === currency.id}
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_label, {
                                    class: "currency-text",
                                    innerHTML: currency.text
                                  }, null, 8, ["innerHTML"]),
                                  _createVNode(_component_ion_radio, {
                                    mode: "md",
                                    slot: "end",
                                    value: currency.id
                                  }, null, 8, ["value"])
                                ]),
                                _: 2
                              }, 1032, ["class"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createBlock("div", _hoisted_13, [
                _createVNode(_component_ion_spinner, { name: "circles" })
              ]))
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withId(() => [
          (!_ctx.wallet.methodId)
            ? (_openBlock(), _createBlock(_component_ion_toolbar, {
                key: 0,
                style: {"padding-top":"10px"}
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_segment, {
                    color: "shiawasedo",
                    value: _ctx.payType,
                    onIonChange: _ctx.changePayMethod
                  }, {
                    default: _withId(() => [
                      (_ctx.showApplePay)
                        ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                            key: 0,
                            value: "apple"
                          }, {
                            default: _withId(() => [
                              _hoisted_14,
                              _createVNode(_component_ion_icon, { icon: _ctx.logoApple }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.showGooglePay)
                        ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                            key: 1,
                            value: "google"
                          }, {
                            default: _withId(() => [
                              _hoisted_15
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_segment_button, { value: "card" }, {
                        default: _withId(() => [
                          _hoisted_16,
                          _createVNode(_component_ion_icon, { icon: _ctx.card }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }),
                      (_ctx.showPayPal)
                        ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                            key: 2,
                            value: "paypal"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.logoPaypal }, null, 8, ["icon"]),
                              _hoisted_17
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.showPaygent)
                        ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                            key: 3,
                            value: "paygent"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_icon, { src: "/assets/icon/unionPay.svg" }),
                              _hoisted_18
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.showWallet && _ctx.isAnother)
                        ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                            key: 4,
                            value: "wallet"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_icon, { src: "/assets/icon/wallet.svg" }),
                              _hoisted_19,
                              _hoisted_20,
                              _createTextVNode(" " + _toDisplayString(_ctx.$tr(_ctx.trCartForm, 'wallet')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["value", "onIonChange"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_grid, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_col, { size: "12" }, {
                        default: _withId(() => [
                          (_ctx.payType === 'apple')
                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                (_ctx.canPay)
                                  ? (_openBlock(), _createBlock(_component_ion_button, {
                                      key: 0,
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.applePayed())),
                                      disabled: _ctx.loading,
                                      expand: "block",
                                      color: "dark"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_icon, {
                                          icon: _ctx.logoApple,
                                          slot: "start"
                                        }, null, 8, ["icon"]),
                                        _hoisted_21
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"]))
                                  : (_openBlock(), _createBlock(_component_ion_button, {
                                      key: 1,
                                      onClick: _ctx.setUpPayment,
                                      disabled: _ctx.loading,
                                      expand: "block",
                                      color: "light"
                                    }, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$tr(_ctx.trCartForm, 'setUp')) + " ", 1),
                                        _createVNode(_component_ion_icon, {
                                          icon: _ctx.logoApple,
                                          slot: "start"
                                        }, null, 8, ["icon"]),
                                        _hoisted_22
                                      ]),
                                      _: 1
                                    }, 8, ["onClick", "disabled"]))
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.payType === 'google')
                            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                (_ctx.canGooglePay)
                                  ? (_openBlock(), _createBlock(_component_ion_button, {
                                      key: 0,
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.googlePayed())),
                                      disabled: _ctx.loading,
                                      expand: "block",
                                      color: "dark"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_23
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"]))
                                  : (_openBlock(), _createBlock(_component_ion_button, {
                                      key: 1,
                                      onClick: _ctx.setUpGooglePayment,
                                      disabled: _ctx.loading,
                                      expand: "block",
                                      color: "light"
                                    }, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$tr(_ctx.trCartForm, 'setUp')) + " ", 1),
                                        _hoisted_24
                                      ]),
                                      _: 1
                                    }, 8, ["onClick", "disabled"]))
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.payType === 'paypal')
                            ? (_openBlock(), _createBlock(_component_pay_pal_button, {
                                key: 2,
                                wallet: _ctx.wallet
                              }, null, 8, ["wallet"]))
                            : _createCommentVNode("", true),
                          (_ctx.payType === 'card')
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 3,
                                expand: "block",
                                color: "shiawasedo",
                                disabled: _ctx.loading,
                                onClick: _ctx.toCardPay
                              }, {
                                default: _withId(() => [
                                  (!_ctx.wallet.methodId)
                                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$tr(_ctx.trCartForm, 'toPay')), 1)
                                      ], 64))
                                    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_ctx.loading ? _ctx.$tr(_ctx.trSignIn, 'loading') : _ctx.$tr(_ctx.trCard, 'pay')), 1)
                                      ], 64))
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"]))
                            : _createCommentVNode("", true),
                          (_ctx.payType === 'paygent')
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 4,
                                expand: "block",
                                color: "shiawasedo",
                                disabled: _ctx.loading,
                                onClick: _ctx.toPaygentPay
                              }, {
                                default: _withId(() => [
                                  (!_ctx.wallet.methodId)
                                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$tr(_ctx.trCartForm, 'toPay')), 1)
                                      ], 64))
                                    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_ctx.loading ? _ctx.$tr(_ctx.trSignIn, 'loading') : _ctx.$tr(_ctx.trCard, 'pay')), 1)
                                      ], 64)),
                                  (_ctx.paygentForm)
                                    ? (_openBlock(), _createBlock("span", {
                                        key: 2,
                                        innerHTML: _ctx.paygentForm
                                      }, null, 8, ["innerHTML"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"]))
                            : _createCommentVNode("", true),
                          (_ctx.payType === 'wallet' && _ctx.isAnother)
                            ? (_openBlock(), _createBlock(_component_wallet_button, {
                                key: 5,
                                wallet: _ctx.wallet
                              }, null, 8, ["wallet"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})